// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4e981fa35da5ac5e","4416":"bb6edf9e4a3340fe","5218":"bb6edf9e4a3340fe","6653":"b7baae246b03091a","7031":"bb6edf9e4a3340fe"}[chunkId] + ".css";
};